export const STATES_FETCH_PROCESSING = 'STATES_FETCH_PROCESSING'
export const STATES_FETCH_SUCCESS = 'STATES_FETCH_SUCCESS'
export const STATES_FETCH_ERROR = 'STATES_FETCH_ERROR'

export const LOCATIONS_FETCH_PROCESSING = 'LOCATIONS_FETCH_PROCESSING'
export const LOCATIONS_FETCH_SUCCESS = 'LOCATIONS_FETCH_SUCCESS'
export const LOCATIONS_FETCH_ERROR = 'LOCATIONS_FETCH_ERROR'
